import { render } from "./home.vue?vue&type=template&id=c23352ec"
const script = {}

import exportComponent from "/Users/xuesinuo/git/youtugz-backend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__